import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import StateCardView from "components/base/StateCardView";
import { Alert } from "components/base/Toast";
import { SUPPLIER_COMPLETE_ONBOARDING } from "../graphql";
import RejectedActionView from "./RejectedActionView";

const ActionsView = ({ supplier }) => {
  const [complete, completeRes] = useMutation(SUPPLIER_COMPLETE_ONBOARDING, {
    variables: { id: supplier.id },
    onCompleted() {
      Alert("success", "Supplier onboarding has been completed.");
    },
    onError(error) {
      Alert("error", error.message);
    },
    refetchQueries: ["FETCH_SUPPLIERS"],
  });

  return (
    <StateCardView primary={supplier.state === "DRAFT"}>
      <h5>Status</h5>
      <div className="mt-2">
        {supplier.state === "DRAFT" && (
          <div>
            This supplier is current in <b>draft</b> state, which is not
            available for orders. Please ask the supplier to submit the
            registration form through Supplier Portal.
          </div>
        )}

        {supplier.state === "PENDING" && (
          <div>
            Supplier has submitted the registration form and is awaiting for
            review. Please review the supplier information and documents.
          </div>
        )}

        {supplier.state === "VERIFIED" && (
          <div>
            <div>This supplier is verified.</div>
            <div className="mt-1">
              To complete the onboarding, please create Vendor(s) in Odoo and
              connect them here. Once completed, you can <b>Complete</b> this
              supplier onboarding process.
            </div>

            {supplier.odooPartners.length > 0 && (
              <Button
                className="mt-4 text-xs"
                primary
                onClick={() => {
                  if (
                    window.confirm(
                      "Are you sure you want to complete the onboarding for this supplier? Once completed, the supplier will be available for orders.",
                    )
                  )
                    complete();
                }}
                loading={completeRes.loading}
              >
                Complete Onboarding
              </Button>
            )}
          </div>
        )}

        {supplier.state === "COMPLETED_ONBOARDING" && (
          <div>
            Supplier has completed the onboarding process and is now available
            for orders.
          </div>
        )}

        {supplier.state === "REJECTED" && (
          <RejectedActionView supplier={supplier} />
        )}
      </div>
    </StateCardView>
  );
};

export default ActionsView;
